import { fetchData } from '@umu/umu-fetch';
import API from '../../path';
import type { IGestureInfo } from '@umu/umu-types';
export type { IGestureInfo } from '@umu/umu-types';

/**
 * 作业动作详情
 */
export const getHomeworkGesture = (gestureId: string): Promise<IResponse<IGestureInfo>> => {
    const api = {
        type: API.GET_GESTURE_DETAIL.type,
        url: `${API.GET_GESTURE_DETAIL.url}/${gestureId}`,
    }
    return fetchData(api);
};
